<template>
    <div class="main">
        <mHead :title="'发现'"></mHead>
        <div class="find">
            <div class="img">
                <img :src="findObject.firstImg.url" alt="">
                <p>{{findObject.firstImg.keyDesc}}</p>
            </div>
            <div class="img">
                <img :src="findObject.secondImg.url" alt="">
                <p>{{findObject.secondImg.keyDesc}}</p>
            </div>
            <div class="bottom clear">
                <div class="img left">
                    <img :src="findObject.bottomImgLeft.url" alt="">
                    <p>{{findObject.bottomImgLeft.keyDesc}}</p>
                </div>
                <div class="img right">
                    <img :src="findObject.bottomImgRight.url" alt="">
                    <p>{{findObject.bottomImgRight.keyDesc}}</p>
                </div>
            </div>
            <img class="logo" src="@/assets/img/CORANGE@3x.png" alt="">
        </div>
        <mBottom></mBottom>
    </div>
</template>

<script>
import mHead from '@/components/base/mobile/mHead.vue'
import mBottom from '@/components/base/mobile/mBottom.vue'
export default {
    name: 'case',
    components:{mHead,mBottom},
    data(){
        return {
            findObject: {
                firstImg: {url:'',keyDesc:''},
                secondImg: {url:'',keyDesc:''},
                bottomImgLeft: {url:'',keyDesc:''},
                bottomImgRight: {url:'',keyDesc:''}
            }
        }
    },
    mounted(){
        this.getList();
    },
    methods: {
        getList(){
            this.$http.get(this.service.dev.api.recommendList+'?pageId=13' ).then(response =>{
              if(response.status == 200) {
                  let list = response.body || [];
                  this.formatData(list)
                
              } else {
                  this.$message.error(response.message?response.message:'error');
              }
            }).catch((res)=>{
                this.$message.error('error');
            })
        },
        formatData(list){
            list.map(item => {
                if(item.keyName == 'firstImg') {
                    this.findObject.firstImg.url = item.content;
                    this.findObject.firstImg.keyDesc = item.keyDesc;
                } else if(item.keyName == 'secondImg') {
                    this.findObject.secondImg.url = item.content;
                    this.findObject.secondImg.keyDesc = item.keyDesc;
                } else if(item.keyName == 'bottomImgLeft') {
                    this.findObject.bottomImgLeft.url = item.content;
                    this.findObject.bottomImgLeft.keyDesc = item.keyDesc;
                } else if(item.keyName == 'bottomImgRight') {
                    this.findObject.bottomImgRight.url = item.content;
                    this.findObject.bottomImgRight.keyDesc = item.keyDesc;
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/base.scss";
.main {
    background: #000000;
    .find {
        padding: poToRem(72) poToRem(20) poToRem(20);
        img {
            display: block;
            width: 100%;
        }
        .logo {
            width: auto;
            height: poToRem(24);
            margin: poToRem(52) auto;
            opacity: 0.1;
        }
        .img {
            width: 100%;
            margin-bottom: poToRem(20);
            position: relative;
            border-radius: poToRem(12);
            overflow: hidden;
            p {
                position: absolute;
                font-size: poToRem(14);
                color: #ffffff;
                left: poToRem(16);
                bottom: poToRem(16);
                line-height: poToRem(16);
            }
        }
        .bottom {
            .img {
                width: calc(50% - 0.2564rem);
                &:first-child {
                    margin-right: poToRem(20);
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/modules/view/find/mobile.vue